import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsRoutingModule } from './reports-routing.module';


import { ChartsModule } from 'ng2-charts';
import { MaterialModule} from './../material.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';


import { ExportService } from './services/export.service';
import { SidenavService } from './services/sidenav.service';
import { ReportsComponent } from './reports.component';
import { ReportDashboardComponent } from './report-dashboard/report-dashboard.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { OpdDateWiseReportComponent } from './OpdReport/opd-date-wise-report/opd-date-wise-report.component';
import { PatientRegistrationDateWiseComponent } from './RegistrationReport/patient-registration-date-wise/patient-registration-date-wise.component';
import { ShareButtonComponent } from './share-button/share-button.component';
import { GraphicalPaitentRegistrationReportComponent } from './RegistrationReport/graphical-paitent-registration-report/graphical-paitent-registration-report.component';
import { PatientCategoryWiseReportComponent } from './RegistrationReport/patient-category-wise-report/patient-category-wise-report.component';
import { PatientRegistrationZoneWiseComponent } from './RegistrationReport/patient-registration-zone-wise/patient-registration-zone-wise.component';
import { OpdDoctorWiseComponent } from './OpdReport/opd-doctor-wise/opd-doctor-wise.component';
import { AppointmentRegisterDoctorWiseComponent } from './OpdAppointment/appointment-register-doctor-wise/appointment-register-doctor-wise.component';
import { RegistrationReportHeaderComponent } from './registration-report-header/registration-report-header.component';
import { OptReportHeaderComponent } from './opt-report-header/opt-report-header.component';
import { SurgeryDateWiseReportComponent } from './SurgeryReports/surgery-date-wise-report/surgery-date-wise-report.component';
import { OperationDateWiseReportComponent } from './SurgeryReports/operation-date-wise-report/operation-date-wise-report.component';
import { OpdMonthWiseReportComponent } from './OpdReport/opd-month-wise-report/opd-month-wise-report.component';
import { SurgeonWiseSummaryReportComponent } from './SurgeryReports/surgeon-wise-summary-report/surgeon-wise-summary-report.component';
import { OperationTypeWiseSummaryComponent } from './SurgeryReports/operation-type-wise-summary/operation-type-wise-summary.component';
import { SurgeonWiseMonthComponent } from './SurgeryReports/surgeon-wise-month/surgeon-wise-month.component';
import { OperationWiseMonthComponent } from './SurgeryReports/operation-wise-month/operation-wise-month.component';
import { OpdreportsComponent } from './OpdReport/opdreports/opdreports.component';
import { RegistrationcommonreportsComponent } from './RegistrationReport/registrationcommonreports/registrationcommonreports.component';
import { ReportPanelComponent } from './report-panel/report-panel.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { AdvanceRegisterComponent } from './receipt-payment/advance-register/advance-register.component';
import { ReceiptPaymentHeaderComponent } from './receipt-payment/receipt-payment-header/receipt-payment-header.component';
import { AppointmentSummaryDoctorWiseReportComponent } from './OpdAppointment/appointment-summary-doctor-wise-report/appointment-summary-doctor-wise-report.component';
import { OpdAppointmentHeaderComponent } from './OpdAppointment/opd-appointment-header/opd-appointment-header.component';
import { misReportComponent } from './mis-report/mis-report.component';
import { ReportsHeaderFooterComponent } from './reports-header-footer/reports-header-footer.component';
import { SendReportEmailComponent } from './send-report-email/send-report-email.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { PreOperativeAssesmentSheetComponent } from './pre-operative-assesment-sheet/pre-operative-assesment-sheet.component';
@NgModule({
  declarations: [
    ReportsComponent,
    ReportDashboardComponent,
    NavbarComponent,
    SidenavComponent,
    OpdDateWiseReportComponent,
    PatientRegistrationDateWiseComponent,
    ShareButtonComponent,
    OpdDoctorWiseComponent,
    GraphicalPaitentRegistrationReportComponent,
    PatientCategoryWiseReportComponent,
    PatientRegistrationZoneWiseComponent,
    AppointmentRegisterDoctorWiseComponent,
    RegistrationReportHeaderComponent,
    OptReportHeaderComponent,
    SurgeryDateWiseReportComponent,
    OperationDateWiseReportComponent,
    OpdMonthWiseReportComponent,
    SurgeonWiseSummaryReportComponent,
    OperationTypeWiseSummaryComponent,
    SurgeonWiseMonthComponent,
    OperationWiseMonthComponent,
    OpdreportsComponent,
    RegistrationcommonreportsComponent,
    ReportPanelComponent,
    AdvanceRegisterComponent,
    ReceiptPaymentHeaderComponent,
    AppointmentSummaryDoctorWiseReportComponent,
    OpdAppointmentHeaderComponent,
    misReportComponent,
    ReportsHeaderFooterComponent,
    SendReportEmailComponent,
    PreOperativeAssesmentSheetComponent
    ],
  imports: [
    CommonModule,
    ReportsRoutingModule,
    ChartsModule,
    MaterialModule,
    FormsModule,
    MatExpansionModule,
    MatListModule,
    MatMenuModule,
    Ng2SearchPipeModule,
    MatAutocompleteModule,
    ReactiveFormsModule
  ],
  exports:[
    OptReportHeaderComponent
  ],
  providers:[SidenavService,ExportService,]
})
export class ReportsModule { }
